import routes from "../routesConfig";

export const adminMenuConfig = [
    {id: "dashboard", path: routes.admin.dashboardFull, labelKey: "dashboard"},
    {
        id: "inquiries",
        path: routes.admin.inquiries.full,
        labelKey: "Požadavky z webu",
        badge: "inquiriesNew",
        children: [
            {id: "inquiries-list", path: routes.admin.inquiries.full, labelKey: "Přehled požadavků", badge: "inquiriesNew"},
            {id: "inquiries-calendar", path: routes.admin.inquiries.calendarFull, labelKey: "Kalendář rezervací"},
            {id: "inquiries-settings", path: routes.admin.inquiries.settingsFull, labelKey: "Rezervace a web", allowedProfiles: ["Admin"]},
        ],
    },
    {id: "repairs", path: routes.admin.repairsFull, labelKey: "repairManagement"},
    {id: "customers", path: routes.admin.customerFull, labelKey: "customers.label"},
    {
        id: "part",
        path: routes.admin.part.base,
        labelKey: "warehouseManagement",
        defaultChildPath: routes.admin.part.categoriesFull,
        children: [
            {id: "part-categories", path: routes.admin.part.categoriesFull, labelKey: "categories"},
            {id: "part-masters", path: routes.admin.part.mastersFull, labelKey: "Master produkty"},
            {id: "part-variants", path: routes.admin.part.variantsFull, labelKey: "Varianty"},
            {id: "part-parameters", path: routes.admin.part.parametersFull, labelKey: "Parametry"},
            {id: "part-items", path: routes.admin.part.itemsFull, labelKey: "warehouse.items"},
        ],
    },
    {id: "part-order", path: routes.admin.partOrder.itemsFull, labelKey: "partOrderManagement"},
    {
        id: "device",
        path: routes.admin.device.base,
        labelKey: "deviceManagement",
        defaultChildPath: routes.admin.device.itemsFull,
        children: [
            {id: "device-categories", path: routes.admin.device.categoriesFull, labelKey: "categories"},
            {id: "device-items", path: routes.admin.device.itemsFull, labelKey: "Zařízení"},
            {id: "device-repair-catalog", path: routes.admin.device.repairCatalogFull, labelKey: "Katalog oprav"},
            {id: "device-diagnostic-catalog", path: routes.admin.device.diagnosticCatalogFull, labelKey: "Položky diagnostiky"},
            {id: "device-repair-times", path: routes.admin.device.repairTimesFull, labelKey: "Časová náročnost oprav"},
        ],
    },
    {id: "buyback", path: routes.admin.buyback.itemsFull, labelKey: "buyback.label"},
    {id: "sales", path: routes.admin.sales.itemsFull, labelKey: "Prodeje"},
    {id: "part-log", path: routes.admin.partLog.partLogsFull, labelKey: "partLog"},
    {id: "users", path: routes.admin.users.itemsFull, labelKey: "users.label", allowedProfiles: ["Admin"]},
    {
        id: "settings",
        path: routes.admin.settings.full,
        labelKey: "Nastavení",
        allowedProfiles: ["Admin"],
        badge: "emailProblems",
        children: [
            {id: "settings-app", path: routes.admin.settings.full, labelKey: "Aplikace"},
            {id: "settings-emails", path: routes.admin.settings.emailsFull, labelKey: "Fronta e-mailů", badge: "emailProblems"},
        ],
    },
];

const hasAllowedProfile = (userProfiles = [], allowedProfiles = []) => {
    if (!allowedProfiles.length) {
        return true;
    }

    return allowedProfiles.some(profile => userProfiles.includes(profile));
};

export const getVisibleMenuItems = (items, userProfiles = []) => {
    return items.reduce((result, item) => {
        if (!hasAllowedProfile(userProfiles, item.allowedProfiles || [])) {
            return result;
        }

        const visibleChildren = item.children ? getVisibleMenuItems(item.children, userProfiles) : undefined;
        if (item.children && !visibleChildren.length) {
            return result;
        }

        result.push({
            ...item,
            children: visibleChildren,
        });

        return result;
    }, []);
};
